import React from "react";

const Item = props => {
  const style = {
    image: {
      maxHeight: "52px",
      maxWidth: "52px"
    },
    label: {
      fontSize: "20px",
      color: "#444445",
      margin: "0px"
    }
  };
  return (
    <div style={{ flex: "1" }}>
      {props.imageName && (
        <img
          src={require(`assets/images/${props.imageName}`)}
          style={style.image}
          alt="Facility"
        />
      )}

      <p style={style.label}>{props.label}</p>
      <div>{props.children}</div>
    </div>
  );
};

export default Item;
